module.exports = __webpack_public_path__ + "static/media/5.e2607b6a.svg";